import { ChatAttachmentItem } from "@src/features/aiAssist/uiComponents/ChatAttachment";
import ChatAttachment from "@src/features/aiAssist/uiComponents/ChatAttachment";
import Text from "@src/lib/ui/Text";

interface Props {
  content: string;
  attachments?: ChatAttachmentItem[] | null;
}

const ChatBubble: React.FC<Props> = ({ content, attachments }) => {
  return (
    <div className="flex w-full max-w-2xl justify-end gap-1">
      {attachments && attachments.length > 0 && (
        <div className="flex flex-wrap gap-1.5 mb-2">
          {attachments.map((attachment, index) => (
            <ChatAttachment key={index} {...attachment} />
          ))}
        </div>
      )}
      <div className="bg-gray-alpha-4 rounded-[20px] py-2 px-4 max-w-[80%]">
        <Text variant="compact-description" multiline>
          {content}
        </Text>
      </div>
    </div>
  );
};

export default ChatBubble;
